module.exports = __webpack_public_path__ + "static/img/demo_opening.3c50bda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/img/demo_opening.jpg
// module id = eJN8
// module chunks = 1